import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { WebpLazyImage } from '../WebpLazyImage/WepbLazyImage'

interface NetworkSelectProps {
  network: string | undefined
  setNetwork: (network: string | undefined) => void
  setMemo: (memo: string) => void
  memo: string | undefined
  show: boolean
  coin: any
  customStyles: any
}

const NetworkSelect = ({ network, setNetwork, setMemo, memo, coin, customStyles, show }: NetworkSelectProps) => {
  if (!show) {
    return null
  }
  const { t } = useTranslation()

  const filterOption = (candidate, input) => {
    input = input.toLowerCase()
    return undefined !== Object.values(candidate.data).find((x: any) => x.toString().toLowerCase().indexOf(input) >= 0)
  }

  return (
    <Fragment>
      <div className="network">
        <Select
          maxMenuHeight={150}
          key={network}
          value={coin?.tokens.find((x) => x.tokenId === network)}
          options={coin?.tokens}
          placeholder={t('wallet.selectNetwork', 'Select network')}
          onChange={(e) => setNetwork(e?.tokenId)}
          styles={customStyles}
          filterOption={filterOption}
          formatOptionLabel={(e) => {
            return (
              <div className="currency-select">
                <WebpLazyImage alt={e.name} src={e.chainLogo} />
                <span>
                  {e.name === 'Ethereum' && e.network === 'NATIVE' ? 'Ethereum ERC20' : `${e.name}(${e.network})`}
                </span>
              </div>
            )
          }}
        />
      </div>
      <div className="address">
        <div className="label">{t('wallet.memo', 'Memo')}</div>
        <input
          placeholder="Optional memo"
          type="text"
          className="value"
          onChange={(e) => setMemo(e.target.value)}
          value={memo}
        />
      </div>
    </Fragment>
  )
}

export default NetworkSelect
